/**
 * 张斌珏整理的最新信息
 *
 * [2022-05-30][iOS 手机迅雷]
 * iOS手雷，@永胜 发的 ua 信息，iThunder 在很早的版本就有，所以这个 ua 信息比较靠谱。
 * ==> Mozilla/5.0 (iPhone; CPU iPhone OS 15_4_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 iThunder XLCloud
 *
 * =========================================================================
 *
 * [2022-05-27][Mac 迅雷]
 * @永胜 发的 Mac 迅雷的UA，MacThunder 的标识符
 * 2021年4月之后的版本：发布的4.0+版本的ua： Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) ClientID/YBJdb1UyFQJwh_nS MacThunder/5.0.1.65431
 *
 * https://gitlab.xunlei.cn/mac/thunder/commit/f0205492e11c42e2bc2a42fbf2182ba68afb168c# ==>
 * 2021年4月之前的版本（目前20%用户活跃,2.5万的日活）：没有 MacThunder。所以使用 MacThunder 判断不会准确。
 * =========================================================================
 *
 * [2022-05-30][Android 手机迅雷]
 * Android 手机迅雷内置的 ua 信息（7.38版本）：
 * 1) 内置的 webview（比如我们自己的活动页）：
 * ==> 'Mozilla/5.0 (Linux; Android 11; 21091116C Build/RP1A.200720.011; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/94.0.4606.85 Mobile Safari/537.36 iThunder;thirdChannel_SHOUJIXUNLEI/7.38.0.9953.7b8 versionCode/13840 xl_cloud statusBarHeight/80 statusBarHeightDp/29.09091 partnerID/0x10800001'
 *
 * 2) 内置的浏览器（即打开第三方站点，下面有前进后退，右上角有收藏按钮的浏览器）（没有 iThunder 标识）
 * ==> 'Mozilla/5.0 (Linux; Android 11; 21091116C Build/RP1A.200720.011; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/94.0.4606.85 Mobile Safari/537.36'
 *
 * 这两个浏览器都支持 window.XLJSWebViewBridge 和 window.XLAccountJsBridge
 */
export const ua = navigator.userAgent;
/**
 * [2022-05-27]
 *【已废弃】【已废弃】已废弃，不推荐使用！！（但不能移除，担心影响旧版本）
 * ==> 因为 isIOS 这个名称有很大的歧义，是判断苹果手机浏览器，还是苹果手机迅雷。(通常是判断苹果手机浏览器环境，但这里居然是判断苹果手机迅雷)
 * 所以如果要判断苹果手机浏览器环境，请使用：isIOSDevice；如果是判断苹果手机迅雷浏览器环境，请使用：isIOSNative
 */
export const isIOS = /(iPhone|iPad).* iThunder/.test(ua);
/**
 * 判断是不是 iOS 系统浏览器环境
 */
export const isIOSDevice = /iPad|iPhone|iPod/.test(ua);
/**
 * 判断 iOS 手机迅雷 webview 环境
 */
export const isIOSNative = isIOSDevice && // 之前是: isIOS
    !!window.WebViewJavascriptBridge &&
    !!window.WebViewJavascriptBridge.callHandler;
// ===================================================================================================================
/**
 * [2022-05-27]
 *【已废弃】【已废弃】已废弃，不推荐使用！！（但不能移除，担心影响旧版本）
 * ==> 因为 isAndroid 这个名称有很大的歧义，是判断Android手机浏览器，还是Android手机迅雷。(通常是判断Android手机浏览器环境，但这里居然是判断Android手机迅雷)
 * 而且兴广也进行了备注：内置新版浏览器没有这个标识，但有XLJSWebViewBridge 和 XLAccountJsBridge,所以需要从native api来判断最准确
 * 所以如果要判断Android手机浏览器环境，请使用：isAndroidDevice；如果是判断Android手机迅雷浏览器环境，请使用：isAndroidNative
 */
export const isAndroid = / Android .* iThunder/.test(ua);
/**
 * 判断是不是 Android 系统浏览器环境
 */
export const isAndroidDevice = /Android/.test(ua);
/**
 * 判断 Android 手机迅雷浏览器环境
 */
export const isAndroidNative = isAndroidDevice && !!window.XLJSWebViewBridge && !!window.XLAccountJsBridge;
// ====================================================================================================================
/**
 * 【已废弃】【已废弃】已废弃，不推荐使用！！已废弃，不推荐使用！！但不能移除，担心影响旧版本。
 * ==> 同样因为 isMac 这个名称有很大的歧义，是判断 mac 系统浏览器，还是 mac 迅雷。(通常是判断 mac 浏览器环境，但这里居然是判断 mac 迅雷)
 * navigator.maxTouchPoints 不准确（之前兴广的注释）
 * 注：navigator.platform 会被废弃，尽早不再使用
 */
export const isMac = navigator.platform === 'MacIntel' && / Mac .* MacThunder/.test(ua);
/**
 * 判断是不是 mac 电脑设备
 * https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
 * macppc|mac68k 的设备太老了，故移除
 */
export const isMacDevice = /(macintosh|macintel)/i.test(ua);
/**
 * [2022-05-27]
 * 只判断 Bridge 这个定义是有问题的，如果 isMacNative 为 true，那么在 iOS 手雷中也会为 true，这会影响作者(使用者)的意图。
 * 故改为：如果不是 iOS 设备，但又有 WebViewJavascriptBridge，那说明在 Mac 迅雷里面。
 */
export const isMacNative = !isIOSDevice && // 新增
    !!window.WebViewJavascriptBridge &&
    !!window.WebViewJavascriptBridge.callHandler;
// ======================================================================================================================
/**
 * Windows PC 迅雷客户端 webview的判断。
 * （注意：如果是web开发的客户端插件，比如群组聊天，是集成到客户端里面，那这个判断会是 false）
 */
const isWindowsXunleiPcWebview = !!window.native && !!window.native.DetachNativeEvent;
/**
 * 【已废弃】【已废弃】已废弃，不推荐使用！！已废弃，不推荐使用！！但不能移除，担心影响旧版本。
 */
export const isPC = isWindowsXunleiPcWebview;
/**
 * 是否在迅雷11内。
 * 请使用这个，语义更明确！！
 */
export const isPCNative = isWindowsXunleiPcWebview;
/**
 * 是否支持xbase 的XBase Jsbridge
 */
export const isXbaseNative = !!window.XBaseObject;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxhdGZvcm0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3BsYXRmb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQTBCRztBQUNILE1BQU0sQ0FBQyxNQUFNLEVBQUUsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDO0FBRXRDOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUFHLDBCQUEwQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUV6RDs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxrQkFBa0IsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7QUFFdkQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQ3RCLFdBQVcsSUFBSSxhQUFhO0lBQzVCLENBQUMsQ0FBQyxNQUFNLENBQUMsdUJBQXVCO0lBQ2hDLENBQUMsQ0FBQyxNQUFNLENBQUMsdUJBQXVCLENBQUMsV0FBVyxDQUFDO0FBRS9DLHNIQUFzSDtBQUV0SDs7Ozs7O0dBTUc7QUFDSCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsc0JBQXNCLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBRXpEOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLFNBQVMsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7QUFFbEQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQzFCLGVBQWUsSUFBSSxDQUFDLENBQUMsTUFBTSxDQUFDLGlCQUFpQixJQUFJLENBQUMsQ0FBQyxNQUFNLENBQUMsaUJBQWlCLENBQUM7QUFFOUUsdUhBQXVIO0FBRXZIOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUNoQixTQUFTLENBQUMsUUFBUSxLQUFLLFVBQVUsSUFBSSxvQkFBb0IsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7QUFFckU7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyx1QkFBdUIsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7QUFFNUQ7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FDdEIsQ0FBQyxXQUFXLElBQUksS0FBSztJQUNyQixDQUFDLENBQUMsTUFBTSxDQUFDLHVCQUF1QjtJQUNoQyxDQUFDLENBQUMsTUFBTSxDQUFDLHVCQUF1QixDQUFDLFdBQVcsQ0FBQztBQUUvQyx5SEFBeUg7QUFFekg7OztHQUdHO0FBQ0gsTUFBTSx3QkFBd0IsR0FDNUIsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxNQUFNLElBQUksQ0FBQyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsaUJBQWlCLENBQUM7QUFFdkQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsd0JBQXdCLENBQUM7QUFFN0M7OztHQUdHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLHdCQUF3QixDQUFDO0FBRW5EOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsV0FBVyxDQUFDIn0=